const ViewTypeEnum = {
	GRID: "grid",
	LIST: "list"
};

const SettingsEnum = {
	POINTS_FILTER: "pointsHashbang"
};

const RefinerTypeEnum = {
	MultiValue: 0,
	Range: 1,
	MultiValueImage: 2
};

const PriceResourceKeys = {
	FROM: "fromText",
	CURRENCY_SYMBOL: "currencySymbol",
	PLUS: "plusSymbol",
	POINTS_TEXT: "pointsText",
	FIRST_INSTALLMENT: "firstInstallmentText",
	PER_MONTH: "perMonthText",
	OR: "orText",
	SECONDARY_PRICE_TEXT: "secondaryPriceText",
	PROMPTPAYMENT_FILTER: "pVPOnlineFilter",
	INSTALLMENT_FILTER: "installmentFilter",
	POINTS_FILTER: "pointsFilter",
	FIDELIZATION_FILTER: "fidelizationFilter",
	ALL_FILTER: "todos"
};

const ColorsToIgnore = ["NA"];

const STOREFRONT_URI = "STOREFRONT_URI";

export class StoreFrontEnums {
	static get VIEWTYPE() {
		return ViewTypeEnum;
	}

	static get REFINER_TYPE() {
		return RefinerTypeEnum;
	}

	static get COLORS_TO_IGNORE() {
		return ColorsToIgnore;
	}

	static get PRICE_RESOURCE_KEYS() {
		return PriceResourceKeys;
	}

	static get SETTINGS() {
		return SettingsEnum;
	}

	static get STOREFRONT_URI() {
		return STOREFRONT_URI;
	}
}
